import React, {useEffect, useState} from 'react';
import {Select} from '@mantine/core';
import {useField} from "formik";
import {ReactComponent as ExclamationIcon} from "../../../assets/systemIcons/ic_exclamation.svg";
import validateRequired from "./utils/validateRequired";

function MantineSelectField(props) {
    const [field, meta, helpers] = useField({
        name: props.name,
        validate: props.isRequired && !props.validation ? validateRequired : props.validation
    });
    const [value, setValue] = useState(field.value);
    const {setValue: setFieldValue, setTouched} = helpers;

    useEffect(() => {
        setValue(field.value);
    }, [field.value]);

    return (
        <Select
            {...props}
            value={value}
            maxDropdownHeight={200}
            nothingFound="Sin resultados"
            radius="md"
            size="md"
            onChange={(v) => {
                setValue(v)
                setFieldValue(v)
                setTouched(props.name, false)
                if (props.onChangeAction) {
                    props.onChangeAction(v)
                }
            }}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
            classNames={{
                wrapper: 'mantine__field__wrapper',
                label: meta.error && meta.touched ? 'mantine__field__label--error' : 'mantine__field__label',
                input: meta.error && meta.touched ? 'mantine__field__field--error' : 'mantine__field__field',
                required: meta.error && meta.touched ? 'mantine__field__required--error' : 'mantine__field__required',
                error: 'mantine__field__error',
                item: 'mantine__field__item',
                rightSection: 'mantine__field__rightSection',
                dropdown: props.notShowData && 'mantine__field__dropdownNotVisible',
            }}
            rightSection={
                meta.error && meta.touched && <ExclamationIcon className="mantine__field__icon"/>
            }
        />
    );
}

export default MantineSelectField;